var locale = {
  placeholder: 'اختيار الوقت'
};
export default locale;